import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBlocker } from 'react-router';

interface UseFormNavigationOptions {
    hasUnsavedChanges: boolean;
    enabled?: boolean;
}

export const useFormNavigation = ({ hasUnsavedChanges, enabled = true }: UseFormNavigationOptions) => {
    const navigate = useNavigate();
    const isNavigatingRef = useRef(false);

    const blocker = useBlocker(enabled && hasUnsavedChanges && !isNavigatingRef.current);

    const navigateBack = (delay: number = 100) => {
        setTimeout(() => {
            navigate(-1);
        }, delay);
    };

    /**
     * Same delay as navigateBack: the blocker is armed from the last render, so
     * navigating in the same tick as clearing the dirty state would be blocked.
     */
    const navigateTo = (path: string, delay: number = 100) => {
        setTimeout(() => {
            navigate(path);
        }, delay);
    };

    const handleConfirmNavigation = () => {
        isNavigatingRef.current = true;
        blocker.proceed?.();
    };

    const handleCancelNavigation = () => {
        blocker.reset?.();
    };

    return {
        blocker,
        navigateBack,
        navigateTo,
        handleConfirmNavigation,
        handleCancelNavigation,
        isNavigatingRef
    };
};
